import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { ChevronDownIcon } from 'components/icons/Icon'
import styles from './styles/NavAvatar.css'

export const NavAvatar = ({ src, bg = 'gray', ...rest }) => {
  const user = useSelector(({ ui }) => ui.user)
  const noImage = !src || src === ''

  const getInitials = () => {
    // If there isn't a user, return empty string
    if (!user) return ''

    // If there is a name, use the initials from the name
    if (user.name) {
      const names = user.name.split(' ')
      const initials = names.map(n => n.charAt(0).toUpperCase())
      return initials.slice(0, 2).join('')
    }

    // If there isn't a name, use the first two letters of the email
    if (user.email) {
      return user.email.charAt(0).toUpperCase() + user.email.charAt(1).toUpperCase()
    }

    // If there is neither a name nor an email, return empty string
    return ''
  }

  const renderImage = () => {
    if (noImage) {
      // If there are no initials, show the default avatar icon
      if (getInitials() === '') {
        return (
          <img alt='avatar' className={styles.image} src={`${CONFIG.assetsBaseURL}/images/icons/person_info.svg`} />
        )
      }

      // Otherwise, show the initials
      return <div className={styles.initials}>{getInitials()}</div>
    }

    return <img alt='avatar' className={styles.image} src={src} />
  }

  return (
    <div className={styles.userIconWrapper} {...rest}>
      <button className={styles.avatarBtn}>
        {renderImage()}
        <ChevronDownIcon size={16} className={styles.downCaret} />
      </button>
    </div>
  )
}

NavAvatar.propTypes = {
  src: PropTypes.string,
  bg: PropTypes.oneOf(['gray', 'white'])
}

export default NavAvatar
